import type { Profile, User } from '~/types/app';

export const mapRequestProfile = (data: any): Profile => {
  const profile: any = {};
  const fields = [];
  data.forEach((item) => {
    const valueType = typeof item.value;

    if (item.value && item.label && typeof item.value !== 'boolean') {
      fields.push(item);
    }
    switch (valueType) {
      case 'string':
      case 'boolean':
        profile[item.name] = item.value;
        profile[`${item.name}Id`] = item.valueId;
        break;
      case 'object':
        profile[item.name] = item.value;
        profile[`${item.name}Id`] = item.valueId;
        break;
      case 'undefined':
        if (item.valueId) {
          profile[item.name] = item.valueId;
        }
    }
  });
  profile.fields = fields;
  if (typeof profile.userContent === 'undefined') {
    profile.userContent = [];
  }

  return profile as Profile;
};

export const mapRequestUser = (data: any): User => {
  const user = {};
  data.forEach((item) => {
    if (item.value) user[item.state] = item.value;
  });
  return user as User;
};
